export const Redirect_To_Error_Page = "Redirect_To_Error_Page";
export const Redirect_To_Login_Page = "Redirect_To_Login_Page";
export const Validate_Input_Field = "Validate_Input_Field";